import React, {forwardRef} from 'react'
import {InputNew} from '@components/common/base/input-new'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export interface InputProps {
  value: string
  onChange?: (value: string) => void
  type?: 'number' | 'text'
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  size?: 'md' | 'lg'
  error?: boolean
  icon?: TablerIcons
  placeholder?: string
  className?: string
  inputClassName?: string
  disabled?: boolean
  step?: number
  min?: number
  max?: number
  /**
   * @deprecated Use UI.Field instead
   */
  label?: React.ReactNode
  mask?: string
  maskPlaceholder?: string
}

export const SharedInput = forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps, ref) => {
    const {
      value,
      onChange,
      type = 'text',
      onFocus,
      onBlur,
      onKeyDown,
      size = 'md',
      error,
      icon,
      placeholder,
      className,
      inputClassName,
      disabled,
      step,
      min,
      max,
      label,
      mask,
      maskPlaceholder
    } = props

    return (
      <InputNew
        value={value}
        onChange={onChange}
        type={type}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        size={size}
        error={error}
        icon={icon}
        placeholder={placeholder}
        className={className}
        inputClassName={inputClassName}
        disabled={disabled}
        step={step}
        min={min}
        max={max}
        mask={mask}
        maskPlaceholder={maskPlaceholder}
        label={label}
        ref={ref}
      />
    )
  }
)
